import { SrcsetParser } from './SrcsetParser'
import { ImageLoader } from './ImageLoader'

export class Texture {
    get width() {
        return this.orig.width
    }
    get height() {
        return this.orig.height
    }
    constructor($img) {
        this.currentSrc = $img
        this.mipmaps = []
        this.mipmapsResolutions = this.getMipmapsResolutions(this.source)
        // console.log(this.mipmapsResolutions)
        this.generateMipmaps()
    }
    getMipmapsResolutions($img) {
        const sortedResolutionsArr = SrcsetParser.getResolutions(this.currentSrc, this.currentSrc.naturalWidth / this.currentSrc.naturalHeight)
        
        return sortedResolutionsArr
    }
    async generateMipmaps() {
        this.mipmapsResolutions.forEach(async (_resolutionObj, index) => {
            const image = await ImageLoader.load(_resolutionObj.url)
            
            if (image) {
                const mipmap = { ..._resolutionObj, image}
                this.mipmaps[index] = mipmap
                // console.log(this.mipmaps[index])
            }
        })
    }
    /**
     * return Image()
     */
    selectMipmap(renderWidth, log = false) {
        // return this.currentSrc // debug
        
        // console.log('selecting mipmap matching', renderWidth, 'among', this.mipmaps)
        
        const selectedMipmap = this.mipmaps.find((element) => element?.width >= renderWidth)
        
        if (selectedMipmap) {
            if (selectedMipmap !== this.selectedMipmap) {
                if (log) console.log('selected mipmap:', selectedMipmap)
                this.selectedMipmap = selectedMipmap
            }
            return selectedMipmap.image
        } else if (this.mipmaps.length) { // the Array.find() returned undefined
            const largestMipmap = this.mipmaps[this.mipmaps.length - 1]
            if (largestMipmap !== this.selectedMipmap) {
                if (log) console.log('selected mipmap:', largestMipmap)
                this.selectedMipmap = largestMipmap
            }
            return largestMipmap.image
        } else {
            if (this.currentSrc.src !== this.selectedMipmap) {
                if (log) console.log('selected mipmap:', this.currentSrc.src)
                this.selectedMipmap = this.currentSrc.src
            }
            return this.currentSrc
        }
    }
}